<template>
  <b-card class="d-flex">
    <b-row>
      <b-col
        v-if="filters.includes('object') || !filters.length"
        md="3"
      >
        <label for="object-filter">{{ $t('objects.object') }}({{ $t('contract.residence') }}):</label>
        <v-select
          id="object-filter"
          v-model="rc_object"
          :options="GET_OBJECTS"
          :reduce="obj => obj.id"
          label="title"
          @input="objectChange"
        />
      </b-col>
      <b-col
        v-if="filters.includes('apartment') || !filters.length"
        md="3"
      >
        <label for="apartment-filter">{{ $t('objects.apartment_block') }}:</label>
        <v-select
          id="apartment-filter"
          v-model="apartment"
          :options="GET_APARTMENTS"
          :reduce="apt => apt.id"
          label="title"
          :disabled="!rc_object"
          @input="apartmentChange"
        />
      </b-col>
      <div
        v-if="clientSession"
        class="ml-auto mt-2 mr-1"
      >
        <b-button @click="endClientSession">
          {{ $t('clients.end') }}
        </b-button>
      </div>
    </b-row>
    <b-row class="p-2">
      <b-form-group
        v-if="filters.includes('rooms_count') || !filters.length"
        :label="$t('objects.numbers_room')+':'"
      >
        <b-form-checkbox-group
          v-model="query_params.rooms_count_list"
          :options="GET_ROOMS_COUNT_BY_APARTMENT"
          buttons
          button-variant="outline-primary"
          size="md"
          name="buttons-2"
          @change="filterFlats"
        />
      </b-form-group>
      <b-col
        md="4"
        sm="12"
      >
        <b-form-group
          v-if="filters.includes('price') || !filters.length"
          :label="$t('objects.price')+':'"
          class="d-flex"
        >
          <div class="d-flex">
            <b-input-group
              class="mr-1"
              :prepend="$t('objects.from')"
            >
              <cleave
                id="number-start"
                v-model="query_params.total_price_start"
                class="form-control"
                :raw="true"
                :options="config"
                placeholder="10,000"
                @input="delayedFilter"
              />
            </b-input-group>
            <b-input-group :prepend="$t('objects.to')">
              <cleave
                id="number-end"
                v-model="query_params.total_price_end"
                class="form-control"
                :raw="true"
                :options="config"
                placeholder="10,000"
                @input="delayedFilter"
              />
            </b-input-group>
          </div>
        </b-form-group>
      </b-col>
      <b-col
        v-if="filters.includes('area') || !filters.length"
        md="3"
        sm="12"
      >
        <b-form-group
          :label="$t('objects.area')+':'"
          class="d-flex"
        >
          <div class="d-flex">
            <b-input-group
              class="mr-1"
              :prepend="$t('objects.from')"
            >
              <b-form-input
                v-model="query_params.total_area_start"
                @input="delayedFilter"
              />
            </b-input-group>
            <b-input-group :prepend="$t('objects.to')">
              <b-form-input
                v-model="query_params.total_area_end"
                @input="delayedFilter"
              />
            </b-input-group>
          </div>
        </b-form-group>
      </b-col>
      <div
        v-if="viewsDropdown"
        class="ml-auto"
      >
        <b-form-group :label="$t('objects.view')">
          <b-dropdown
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            right
            menu-class="w-100"
          >
            <template #button-content>
              <feather-icon :icon="getActiveView.icon" />
              {{ getActiveView.text }}
            </template>
            <b-dropdown-item
              v-for="option in view_options"
              :key="option.id"
              class="d-inline-block"
              @click="changeView(option.id)"
            >
              <feather-icon :icon="option.icon" />
              <span
                style="white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;"
                class="text-truncate"
              >
                {{ option.text }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </b-form-group>
      </div>
    </b-row>
    <div class="d-flex">
      <b-form-group
        v-if="filters.includes('status') || !filters.length"
        :label="$t('objects.status')+':'"
      >
        <b-form-checkbox-group
          v-model="query_params.current_status"
          size="md"
          @change="filterFlats"
        >
          <b-form-checkbox
            v-for="option in GET_FLAT_STATUSES"
            :key="option.id"
            :class="`custom-control-${option.color}`"
            :value="option.id"
          >
            {{ option.title[$i18n.locale] }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <!-- <div class="mr-1">
          <b-badge
            class="p-50"
            variant="success"
          >
            {{ ' ' }}
          </b-badge>
          <span class="pb-25">
            Свободные
          </span>
        </div>
        <div class="mr-1">
          <b-badge
            class="p-50"
            variant="warning"
          >
            {{ ' ' }}
          </b-badge>
          Забронированные
        </div>
        <div class="mr-1">
          <b-badge
            class="p-50"
            variant="secondary"
          >
            {{ ' ' }}
          </b-badge>
          Проданные
        </div>
        <div>
          <b-badge
            class="p-50"
            variant="primary"
          >
            {{ ' ' }}
          </b-badge>
          Занятые
        </div> -->
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BFormGroup, BFormCheckboxGroup, BRow, BCol, BDropdown, BDropdownItem,
  BFormCheckbox, BInputGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
import VSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BFormGroup,
    BFormCheckboxGroup,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BInputGroup,
    BFormInput,
    FeatherIcon,
    Cleave,
    VSelect,
    BButton,
  },
  props: {
    activeView: {
      type: [Number, String],
      required: false,
      default: 1,
    },
    viewsDropdown: {
      type: Boolean,
      required: false,
      default: false,
    },
    filters: {
      type: Array,
      required: false,
      default() {
        return ['rooms_count', 'price', 'area', 'status', 'apartment', 'object']
      },
    },
    queryParams: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    def_object: {
      type: [Number, String],
      required: false,
      default: null,
    },
    def_apartment: {
      type: [Number, String],
      required: false,
      default: null,
    },
    objectOptions: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
    clientSession: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      query_params: {
        id: this.$route.params.id,
        page: 1,
        page_size: 5,
        apartment: this.$route.params.id,
        rooms_count_list: [],
        total_area_start: '',
        total_area_end: '',
        total_price_end: '',
        total_price_start: '',
        current_status: [],
      },
      rc_object: null,
      apartment: null,
      config: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      },
      active_view: 1,
      view_options: [
        {
          icon: 'GridIcon',
          text: this.$t('objects.tile'),
          id: 1,
        },
        {
          icon: 'AlignJustifyIcon',
          text: this.$t('objects.list'),
          id: 2,
        },
        {
          icon: 'ListIcon',
          text: this.$t('objects.plannings'),
          id: 3,
        },
        // {
        //   icon: 'SquareIcon',
        //   text: 'Этажи',
        //   id: 4,
        // },
      ],
    }
  },
  computed: {
    ...mapGetters('objects', ['GET_OBJECTS']),
    ...mapGetters('apartments', ['GET_APARTMENTS', 'GET_ROOMS_COUNT_BY_APARTMENT']),
    ...mapGetters('knowledgeBase', ['GET_FLAT_STATUSES']),
    getActiveView() {
      return this.view_options.find(el => el.id === this.active_view)
    },
  },
  watch: {
    active_view() {
      this.$emit('update:activeView', this.active_view)
    },
    query_params: {
      handler(newVal) {
        this.$emit('update:queryParams', newVal)
      },
      deep: true,
    },
    def_object(newVal) {
      this.rc_object = newVal
      // this.objectChange()
    },
    def_apartment(newVal) {
      this.apartment = newVal
      // this.apartmentChange()
    },
  },
  mounted() {
    // this.FETCH_OBJECTS()
    this.FETCH_FLAT_STATUSES().then(() => {
      this.GET_FLAT_STATUSES.forEach(el => {
        this.query_params.current_status.push(el.id)
      })
    })
  },
  methods: {
    ...mapActions('objects', ['FETCH_OBJECTS']),
    ...mapActions('apartments', ['FETCH_APARTMENTS_BY_OBJECT', 'FETCH_ROOMS_COUNT_BY_APARTMENT']),
    ...mapActions('knowledgeBase', ['FETCH_FLAT_STATUSES']),
    objectChange() {
      if (this.rc_object) {
        // this.FETCH_APARTMENTS_BY_OBJECT({ id: this.rc_object })
        this.$emit('objectChanged', this.rc_object)
      } else {
        this.apartment = null
      }
    },
    changeView(id) {
      this.active_view = id
    },
    apartmentChange() {
      if (this.apartment) this.FETCH_ROOMS_COUNT_BY_APARTMENT(this.apartment)
      this.$emit('apartmentChanged', this.apartment)
      // this.$parent.$emit('apartmentChanged', this.apartment)
    },
    delayedFilter() {
      this.$emit('delayedFilter')
    },
    filterFlats() {
      this.$emit('filterFlats')
    },
    endClientSession() {
      this.$emit('sessionEnd')
    },
  },
}
</script>

<style>

</style>
